import store from '@/store/index'

export default {
  inserted(el, binding, vnode) {
    const { value } = binding
    const user = store.state.userInfo

    if (value) {
      let userAuthCodes = []
      let codes = user.auth_codes
      if (codes && codes.length > 0) {
        userAuthCodes = codes[0].Codes
      }

      let code = value.pAuthCode

      if (code == "" || value.platform == "none") {
        el.parentNode && el.parentNode.removeChild(el)
        return
      }

      const hasPermission = userAuthCodes.includes(code)
      if (!hasPermission && !user.is_super_admin) {
        el.parentNode && el.parentNode.removeChild(el)
        return
      }

    } else {
      // console.log("auth code error!")
      // throw new Error("auth code error!")
    }
  }
}
